import React, { Component } from 'react';
import moment from 'moment';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';

import SiteAnalytics from '../../components/SiteAnalytics/SiteAnalytics';
import Report from '../Report/Report';

import { StateContext, useState } from '../../state/StateProvider';

const { Title } = Typography;

const ReportPage = () => {
    const { state, setSelectedJobId } = useState();
    const { analytics, site, jobs, products, productsLoading, selectedJobId } = state;

    const job = jobs[selectedJobId];
    const jobAnalytics = analytics[selectedJobId];
    const jobProducts = products[selectedJobId];

    const onOpenReport = async selectedJobId => {
        setSelectedJobId(selectedJobId);
    }

    const openFullReport = () => {
        const { selectedJobId, site } = state;
        if (!selectedJobId || !site || !site.siteId ) return null;
        return window.open(`https://app.amzwatcher.com/app/report/${site.siteId}/${selectedJobId}`, '_blank');
    }

    return (
        <div>
            <Title style={{ textAlign: 'left', margin: '10px 0 10px 0' }} level={3}>
                Report from {job && moment(job.dateScheduled).format('DD MMM, HH:MM:SS')} 
            </Title>
            <div>
                <Button onClick={() => onOpenReport(null)} icon={<LeftOutlined />} size="small" style={{ marginRight: 10 }}>All Reports</Button> 
                <Button size="small" onClick={openFullReport}>See Full Report on AMZWatcher.com</Button>
            </div>
            <SiteAnalytics analytics={jobAnalytics} site={site} job={job} />
            <Report job={job} products={jobProducts} loading={productsLoading} />
        </div>
    ); 
}

export default ReportPage;